import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-upcoming-trip-empty',
    templateUrl: './upcoming-trip-empty.component.html',
    styleUrls: ['./upcoming-trip-empty.component.scss'],
    imports: [MatButton]
})
export class UpcomingTripEmptyComponent {

}
